module.exports = __webpack_public_path__ + "static/img3-263a51cf8f78ac28ffed8dd791b436f3.png";